
import { ViewContext } from "@/components/movie/buttons/types";

/**
 * Determines the correct button context based on component usage
 */
export const getButtonContext = (
  viewMode?: "grid" | "list",
  variant?: "list" | "search" | "dialog" | "detail",
  isSearchResult?: boolean,
  isDialog?: boolean
): ViewContext => {
  // Dialog/detail pages take highest priority
  if (isDialog || variant === "dialog" || variant === "detail") {
    return "dialog";
  }
  
  // Search results
  if (isSearchResult || variant === "search") {
    return "search";
  }
  
  // List view
  if (viewMode === "list" || variant === "list") {
    return "list";
  }
  
  // Default to grid
  return "grid";
};
